export default "__VITE_ASSET__CqivNDWs__"